import { Locale } from "../Locale.js";
import { localizePathMap } from "./localizePathMap.js";

export const cookiesPathMap = localizePathMap({
	[Locale.cs]: "cookies",
	[Locale.en]: "cookies",
});
